import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import VisaIcon from "../../icons/visa.png"
import JCBIcon from "../../icons/jcb.png"
import MaestroIcon from "../../icons/maestro.png"
import DiscoverIcon from "../../icons/discover.png"
import AmericanExpressIcon from "../../icons/american_express.png"
import DinnerClubIcon from "../../icons/dinner_club.png"

const tlf_logo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf_logo_2.svg";
const jpt_logo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jpt_logo.svg";
const Footer = () => {
  const { t, i18n } = useTranslation();
  return (
    <footer>
      <div className="tw:flex tw:flex-wrap">
        <div className="tw:w-full tw:lg:w-1/2 tw:p-0 tw:flex tw:flex-col">
          <div className="tw:bg-[#54162a] tw:h-full tw:flex tw:items-stretch">
            <div className="tw:w-full tw:py-7 tw:xl:py-[42px] tw:px-5 tw:xl:px-[75px]">
              <div className="tw:flex tw:flex-col tw:xl:flex-row tw:xl:items-start tw:gap-4 tw:xl:gap-[90px]">
                <img
                  src={tlf_logo}
                  alt="logo"
                  className="tw:w-[74px] tw:xl:w-auto"
                />
                <div className="">
                  <div className="tw:font-hanken-grotesk tw:text-[#DBBE78] tw:text-xs tw:xl:text-[13px] tw:leading-[17px]">
                    {t("Footer.Tokyo.Chauffeured.Journeys")} <br />
                    <br />
                    <span className="tw:font-libre-caslon-display tw:text-lg tw:xl:text-[22px] tw:leading-[24px] tw:xl:leading-[26px]">
                      {t("Footer.tlf")}
                    </span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("Footer.tlf.address1"),
                      }}
                    ></span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("Footer.tlf.address2"),
                      }}
                    ></span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("Footer.tlf.address3"),
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tw:w-full tw:lg:w-1/2 tw:p-0 tw:flex tw:flex-col">
          <div className="tw:bg-black tw:h-full tw:flex tw:items-stretch">
            <div className="tw:w-full tw:py-7 tw:xl:py-[42px] tw:px-5 tw:xl:px-[75px]">
              <div className="tw:flex tw:flex-col tw:xl:flex-row tw:xl:items-start tw:gap-4 tw:xl:gap-[90px]">
                <img
                  src={jpt_logo}
                  alt="logo"
                  className="tw:w-[74px] tw:xl:w-[110px]"
                />
                <div className="">
                  <div className="tw:font-hanken-grotesk tw:text-white tw:text-xs tw:xl:text-[13px] tw:leading-[17px]">
                    {t("Footer.Non-Tokyo.Transfers")}
                    <br />

                    <br />
                    <span className="tw:font-libre-caslon-display tw:text-lg tw:xl:text-[22px] tw:leading-[24px] tw:xl:leading-[26px]">
                      {t("Footer.jpt")}
                    </span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("Footer.jpt.address1"),
                      }}
                    ></span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("Footer.jpt.address2"),
                      }}
                    ></span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("Footer.jpt.address3"),
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tw:pt-12 tw:pb-14 tw:!mx-0 tw:!bg-[#F4F4F4]">
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-4 tw:md:gap-0 tw:sm:flex-wrap">
          <div className="tw:flex-1 tw:space-y-0 tw:md:space-y-[14px] tw:md:!px-[75px]">
            <div className="tw:flex tw:items-center tw:gap-[42px] tw:justify-center tw:lg:justify-start">
              <div>
                <Link
                  className={`tw:!text-[#212529] tw:!font-hanken-grotesk tw:!no-underline tw:text-sm`}
                  to="/"
                >
                  {t("Footer.Home")}
                </Link>
              </div>

              <div>
                <Link
                  className={`tw:!text-[#212529] tw:!font-hanken-grotesk tw:!no-underline tw:text-sm`}
                  to="/about"
                >
                  {t("Footer.About")}
                </Link>
              </div>

              <div>
                <Link
                  className={`tw:!text-[#212529] tw:!font-hanken-grotesk tw:!no-underline tw:text-sm`}
                  to="/careers"
                >
                  {t("Footer.Careers")}
                </Link>
              </div>
            </div>
            <div className="tw:flex tw:items-center tw:gap-[42px] tw:justify-center tw:mt-[14px] tw:xl:mt-0 tw:lg:justify-start">
              <div>
                <Link
                  className={`tw:!text-[#212529] tw:!font-hanken-grotesk tw:!no-underline tw:text-sm`}
                  to={i18n.language === "en" || i18n.language === "EN" ? "/en/cancellation-policy" : "/jp/cancellation-policy"}
                >
                  {t("Footer.Cancellation.Policy")}
                </Link>
              </div>
              <div>
                <Link
                  className={`tw:!text-[#212529] tw:!font-hanken-grotesk tw:!no-underline tw:text-sm`}
                  to={i18n.language === "en" || i18n.language === "EN" ? "/en/maps?type=haneda-airport&t=1" : "/jp/maps?type=haneda-airport&t=1"}
                >
                  {t("Footer.Maps")}
                </Link>
              </div>
              <div>
                <Link
                  className={`tw:!text-[#212529] tw:!font-hanken-grotesk tw:!no-underline tw:text-sm`}
                  to="/contact"
                >
                  {t("Footer.Contact")}
                </Link>
              </div>
            </div>
            <div className="tw:w-auto tw:flex tw:justify-center tw:lg:justify-start tw:flex-row tw:mt-[22px] tw:xl:mt-3 tw:lg:mb-0">
              <a
                href="https://api.whatsapp.com/send?phone=818068628008"
                className="tw:py-0 tw:px-2 tw:no-underline tw:cursor-pointer"
              >
                <i className="bi bi-whatsapp tw:text-[#4e4e4e] tw:text-[24px]"></i>
              </a>
              <a
                href="https://www.instagram.com/theluxuryfleet/"
                target="_blank"
                className="tw:py-0 tw:px-2 tw:no-underline tw:cursor-pointer"
              >
                <i className="bi bi-instagram tw:text-[#dbbe78] tw:text-[15px] tw:max-lg:text-[13px]"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UC8dlq5-c7jnAiZ4j8dzK3Cg"
                target="_blank"
                className="tw:py-0 tw:px-2 tw:no-underline tw:cursor-pointer"
              >
                <i className="bi bi-youtube tw:text-[#dbbe78] tw:text-[15px] tw:max-lg:text-[13px]"></i>
              </a>
            </div>
          </div>
          <div className="tw:flex-1 tw:mx-[42px] tw:xl:!mx-[75px]">
            <div className="tw:text-center tw:xl:text-end tw:mt-9 tw:md:mt-0">
              <div
                className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:text-[#4E4E4E]"
                dangerouslySetInnerHTML={{
                  __html: t("Footer.AcceptPaymentMethod"),
                }}
              >
                {/* We accept credit cards for online reservations made through our website */}
              </div>
            </div>
            <div className="tw:flex tw:items-center tw:justify-center tw:lg:justify-end tw:xl:w-[425px] tw:xl:ml-auto tw:gap-5 tw:mt-4">
              <img src={VisaIcon} alt="Visa" />
              <img src={JCBIcon} alt="JCB" />
              <img src={MaestroIcon} alt="Maestro" />
              <img src={DiscoverIcon} alt="Discover" />
              <img src={AmericanExpressIcon} alt="American Express" />
              <img src={DinnerClubIcon} alt="Dinner Club" />

            </div>
            {/* <div className="d-flex justify-content-end mt-2"> */}
            <div className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:text-[#4E4E4E] tw:mt-4 tw:xl:mt-[26px] tw:text-center tw:lg:!text-end">
              <Trans
                className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:text-[#4E4E4E]"
                i18nKey={`Footer.BankTransfer`}
                components={{
                  a: (
                    <a className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:!text-[#4E4E4E] tw:font-bold"></a>
                  ),
                }}
              />
            </div>
          </div>
        </div>
        <hr className="tw:!border tw:!border-[#C9C9C9] tw:!border-[0.75px] tw:!my-[35px]" />
        <div className="d-flex flex-column align-items-center tw:!gap-1">
          <div className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:text-[#4E4E4E] tw:xl:mt-[26px]">
            <Trans
              className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:text-[#4E4E4E]"
              i18nKey={`Footer.WebisteManagedBy`}
              components={{
                a: (
                  <a className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:!text-[#4E4E4E] tw:!no-underline"></a>
                ),
              }}
            />
          </div>
          <div className="tw:font-hanken-grotesk tw:text-[13px] tw:leading-[18.5px] tw:text-[#4E4E4E]">
            {t("Footer.Copyright", { year: new Date().getFullYear() })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
